import colors from './colors.module.scss';
import variables from './variables.module.scss';

export const CrmMUITheme = {
  typography: {
    fontFamily: variables.DEFAULT_FONT,
    fontWeight: variables.LIGHT,
  },
  overrides: {
    MuiTypography: {
      caption: {
        color: '#1E201F',
        fontSize: '12px',
      },
      root: {
        fontSize: '12px!important',
      },
    },
    MuiPaper: {
      root: {
        color: colors.DEFAULT_FONT_COLOR + '!important',
        borderRadius: '0px',
        zIndex: '0',
        border: '1px solid #E8E9EB',
        backgroundColor: 'transparent',
      },
      elevation1: {
        boxShadow: 'none!important',
        border: '0px!important',
      },
      elevation2: {
        boxShadow: 'none!important',
        border: '0px!important',
      },
      elevation4: {
        boxShadow: 'none !important',
      },
      elevation8: {
        boxShadow: 'none',
      },
      elevation24: {
        boxShadow: 'none !important',
      },
    },
    MuiButton: {
      root: {
        color: colors.DEFAULT_FONT_COLOR,
        borderRadius: '0px',
        '&.add-client-button': {
          minWidth: 'unset',
        },
      },
      startIcon: {
        marginLeft: '-2px',
        marginRight: '20px',
      },
      textPrimary: {
        textTransform: 'none',
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
      outlined: {
        border: '1px solid #EBE9EB',
      },
    },
    MuiDrawer: {
      paper: {
        borderRight: 'none!important',
        backgroundColor: '#E8E9EB',
        zIndex: '3',
      },
      paperAnchorDockedLeft: {
        borderRight: 'none!important',
        backgroundColor: '#E8E9EB',
        zIndex: '3',
      },
      paperAnchorRight: {
        borderLeft: 'none!important',
        backgroundColor: '#E8E9EB',
        zIndex: '4',
      },
    },
    MuiListItem: {
      root: {
        justifyContent: 'flex-start !important',
        height: '48px',
        width: '100%!important',
        marginTop: '-1px',
        position: 'relative',
        borderBottom: '1px solid #CACBD3',
        padding: '0px !important',
        '&:hover': {
          backgroundColor: '#CACBD3',
        },
        '&$selected': {
          borderBottom: '1px solid #f5f5fc',
          borderTop: '1px solid #f5f5fc',
          zIndex: '2',
          backgroundColor: colors.BACKGROUND_PAGE,
          '&:active': {
            backgroundColor: colors.BACKGROUND_PAGE,
          },
          '&:hover': {
            borderBottom: '1px solid #CACBD3',
            borderTop: '1px solid #CACBD3',
          },
          '& div.navbar-image-size': {
            borderLeft: '2px solid #585bd7 !important',
            paddingLeft: '6px!important',
          },
        },
      },
    },
    MuiMenu: {
      paper: {
        width: '100px',
        borderRadius: '0px',
      },
      list: {
        padding: '0px!important',
        width: '100%!important',
      },
    },
    MuiMenuItem: {
      root: {
        paddingLeft: '5px',
        width: '100%',
        minHeight: '32px',
        backgroundColor: '#E8E9EB',
        fontSize: '12px',
        border: '0px',
        '&$selected': {
          backgroundColor: '#1E201F',
          color: 'white',
          border: '0px',
          width: '100%',
          '&:hover': {
            backgroundColor: '#CACBD3',
          },
        },
        '&:hover': {
          backgroundColor: '#CACBD3',
        },
      },
    },
    MuiToggleButtonGroup: {
      root: {
        backgroundColor: '#E8E9EB',
        border: 'none',
        borderRadius: '0px',
      },
    },
    MuiToggleButton: {
      root: {
        border: 'none',
        marginRight: '5px',
        color: '#1E201F',
        fontSize: '18px',
        height: '18px',
        borderRadius: '0px',
        fontWeight: '600',

        '&$selected': {
          backgroundColor: '#E8E9EB',
          textDecoration: 'underline',
          color: '#1E201F',
          '&:hover': {
            backgroundColor: '#E8E9EB',
            textDecoration: 'underline',
          },
        },
        '&:hover': {
          backgroundColor: '#E8E9EB',
        },
      },
    },
    MuiTableCell: {
      root: {
        borderBottomWidth: '0px!important',
        borderTopWidth: '0px!important',
        fontSize: '14px',
      },
      body: {
        fontWeight: '600',
        padding: '5px 16px 5px 16px!important',
      },
      head: {
        textTransform: 'uppercase',
        fontWeight: '700',
        backgroundColor: '#E8E9EB!important',
        fontSize: '14px',
        whiteSpace: 'nowrap',
        zIndex: '0!important',
        padding: '5px 16px 5px 16px!important',
        flexDirection: 'row!important',
      },
      footer: {
        width: 'fit-content!important',
        overflowX: 'hidden!important',
        '@media (max-width: 320px)': {
          position: 'relative',
          left: '-16px',
        },
      },
    },
    MuiTableRow: {
      root: {
        backgroundColor: 'white !important',
        height: '56px!important',
      },
      footer: {
        backgroundColor: 'transparent !important',
      },
    },
    MuiTablePagination: {
      toolbar: {
        display: 'flex',
        flexFlow: 'row-reverse',
        backgroundColor: 'transparent!important',
      },
    },
    MuiToolbar: {
      root: {
        paddingLeft: '0px!important',
        paddingRight: '0px!important',
        flexWrap: 'wrap',
      },
      gutters: {
        paddingLeft: '0px!important',
        paddingRight: '0px!important',
        flexWrap: 'wrap',
      },
    },
    MuiSelect: {
      root: {
        border: '1px solid #E8E9EB!important',
        padding: '4px 25px 4px 5px!important',
        color: 'black',
        fontSize: '12px',
        fontFamily: 'Lato',
      },
    },

    MuiIconButton: {
      root: {
        color: 'black',
        '&:hover': {
          backgroundColor: 'none !important',
        },
      },
      colorPrimary: {
        color: '#EEEEEE !important',
      },
      edgeEnd: {
        marginRight: '5px!important',
      },
    },
    MuiInput: {
      root: {
        lineHeight: 'normal!important',
      },
      input: {
        //fix ipad/iphone
        '@media (max-width: 599px)': {
          lineHeight: 'normal',
        },
        fontSize: '14px',
        color: 'black',
        fontWeight: '600',
      },
      underline: {
        '&:before': {
          borderBottom: '1px solid #E8E9EB',
        },
        '&:after': {
          borderBottom: '2px solid #585bd7',
        },
        '&&&&:hover:before': {
          borderBottom: '1px solid #CACBD3',
        },
      },
    },
    MuiTableSortLabel: {
      root: {
        display: 'flex',
        justifyContent: 'space-between',
      },
      icon: {
        height: '25px',
        width: '25px',
      },
    },
    MuiFormControl: {
      root: {
        padding: '0px!important',
      },
    },
    MuiTooltip: {
      tooltip: {
        borderRadius: '2px',
        fontSize: '14px',
      },
      popperArrow: {
        left: 'calc(50% - 12px)',
      },
      arrow: { color: 'rgba(30, 32, 31, 0.95)', width: '25px', height: '18px' },
    },
    MuiSnackbar: {
      anchorOriginTopCenter: {
        top: '60px !important',
      },
    },
    MuiRadio: {
      root: {
        color: '#EEEEEE',
        paddingRight: '0px !important',
        '&$checked': {
          color: '#585bd7 !important',
        },
        '&:hover': {
          backgroundColor: 'transparent!important',
        },
      },
    },
    MuiCheckbox: {
      root: {
        color: '#E8E9EB',
        paddingLeft: '0px !important',
        '&$checked': {
          color: '#585bd7 !important',
        },
        '&.checkboxshare$checked': {
          color: '#585bd7!important',
        },
        '&:hover': {
          backgroundColor: 'transparent!important',
        },
      },
      colorSecondary: {
        color: '#E8E9EB !important',
        '&.checkboxpay': {
          color: '#989898!important',
        },
        '&.checkboxpay-disabled': {
          color: '#EEEFEF !important',
        },
        '&.checkboxshare': {
          color: '#989898!important',
        },
        '&.checkboxdisabled': {
          '&.Mui-disabled': {
            '& .MuiSvgIcon-root': {
              color: '#989898',
              backgroundColor: '#989898',
              borderRadius: 3,
              width: 18,
              height: 18,
              marginLeft: 3,
            },
          },
        },
      },
    },
    MuiAvatar: {
      root: {
        width: '24px',
        height: '24px',
        marginRight: '8px',
      },
      img: {
        width: '24px',
        height: '24px',
      },
    },
    MuiIcon: {
      root: {
        fontSize: '18px',
      },
    },
    MuiStepIcon: {
      root: {
        width: '40px',
        height: '40px',
        color: '#E8E9EB',
      },
      active: {
        color: '#585bd7!important',
      },
      completed: {
        color: '#585bd7!important',
      },
      text: {
        fill: '#989898',
        fontSize: '0.65rem',
      },
    },
    MuiStepLabel: {
      labelContainer: {
        fontSize: '14px',
      },
      label: {
        fontWeight: '900',
        color: 'black',
      },
      active: {
        fontWeight: '900!important',
      },
      completed: {
        fontWeight: '900!important',
      },
    },
    MuiStepConnector: {
      lineHorizontal: {
        borderColor: '#E8E9EB',
      },
      alternativeLabel: {
        top: '20px',
      },
      active: {
        '& $line': {
          borderColor: '#585bd7!important',
        },
      },
      completed: {
        '& $line': {
          borderColor: '#585bd7!important',
        },
      },
    },
    MuiAutocomplete: {
      root: {
        width: '100%',
      },
      endAdornment: {
        top: 'auto',
      },
      popper: {
        backgroundColor: 'white',
      },
      option: {
        padding: '0px',
        paddingLeft: '10px !important',
        color: 'black',
        fontWeight: '600',
        border: '0px !important',
        textTransform: 'capitalize',
        backgroundColor: 'white !important',
        '&:hover': {
          color: 'white',
          backgroundColor: '#585bd7 !important',
        },
      },
      popupIndicator: {
        '& span': {
          '& svg': {
            '& path': {
              d: "path('M 16.59 8.59 L 12 13.17 L 7.41 8.59 L 6 10 l 6 6 l 6 -6 Z')",
            },
          },
        },
        '&:hover': {
          backgroundColor: 'transparent !important',
        },
      },
    },
    MuiFormLabel: {
      filled: {
        width: '250px',
      },
      root: {
        fontSize: '14px',
      },
    },
    MuiInputLabel: {
      root: {
        height: '15px',
        display: 'flex',
      },
    },
    MuiAppBar: {
      root: {
        border: '0px !important',
      },
      colorPrimary: {
        backgroundColor: 'unset',
        border: 'unset',
      },
    },
    MuiTab: {
      root: {
        minWidth: '10px !important',
        maxWidth: '210px !important',
        width: '44%',
        textTransform: 'none !important',
        marginRight: '8px !important',
        borderTop: '1px solid #E8E9EB !important',
        borderLeft: '1px solid #E8E9EB !important',
        borderRight: '1px solid #E8E9EB !important',
        lineHeight: '1',
        '@media (max-width: 1000px)': {
          maxWidth: '156px  !important',
          lineHeight: '1.1',
        },
        '@media (max-width: 750px)': {
          maxWidth: '82px !important',
          marginRight: '5px !important',
          lineHeight: '1.1',
        },
      },
      textColorInherit: {
        fontSize: '16px',
        color: 'black',
        fontFamily: 'Lato',
        fontWeight: '400',
        '@media (max-width: 1000px)': {
          fontSize: '14px',
        },
        '@media (max-width: 750px)': {
          fontSize: '12px',
        },
        '&$selected': {
          color: '#585bd7!important',
          fontWeight: '700!important',
          backgroundColor: '#f6f7f7',
          position: 'relative',
          zIndex: '2',
          marginBottom: '-1px',
        },
      },
    },
    MuiTabs: {
      root: {
        overflowX: 'auto',
        overflowY: 'hidden',
        marginBottom: '-1px',
        paddingBottom: '1px',
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent',
          height: '6px',
        },
        '&::-webkit-scrollbar': {
          backgroundColor: 'rgba(232, 233, 235, 0.38)',
          height: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
          border: '2px solid transparent',
          borderRadius: '4px',
          backgroundColor: 'rgba(0, 0, 0, .09)',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: 'rgba(0, 0, 0, .4)',
        },
      },
      scroller: {
        overflow: 'unset !important',
      },
      indicator: {
        backgroundColor: 'rgba(232, 233, 235, 0)!important',
      },
      flexContainer: {
        height: '55px',
      },
    },
    MuiFormGroup: {
      root: {
        flexDirection: 'row',
      },
    },
    MuiFormControlLabel: {
      root: {
        marginRight: '10px',
      },
      label: {
        fontWeight: 600,
      },
    },
    MuiSwitch: {
      root: {
        width: 'fit-content !important',
        height: 'fit-content!important',
        overflow: 'visible!important',
      },
      thumb: {
        width: '25px!important',
        height: '25px!important',
      },
      track: {
        height: '15px!important',
        width: '40px!important',
        opacity: '0.24!important',
      },
      switchBase: {
        top: '-2px!important',
        left: '-10px!important',
        color: '#F1F1F1!important',
        '&$checked': {
          color: '#585bd7 !important',
          left: '10px!important',
          '& + $track': {
            backgroundColor: '#585bd7 !important',
            opacity: '0.24!important',
          },
        },
      },
    },
    MuiBackdrop: {
      root: {
        backgroundColor: 'rgba(0, 0, 0, 0.25)',
      },
    },
    MuiExpansionPanel: {
      root: {
        width: '100%',
        padding: '0',
        marginTop: '10px',
        '&:before': {
          position: 'unset',
        },
        '&$expanded': {
          marginTop: '10px',
          marginBottom: '0px',
        },
      },
    },
    MuiExpansionPanelSummary: {
      root: {
        paddingLeft: '4px',
        paddingRight: '4px',
        borderBottom: '1px solid #E8E9EB !important',
        height: '68px',
        '&$expanded': {
          height: '68px',
        },
      },
      expandIcon: {
        '&$expanded': {
          marginRight: '-8px !important',
        },
      },
      content: {
        fontSize: '14px',
        fontWeight: '600',
        margin: '16px 0',
      },
    },
    MuiExpansionPanelDetails: {
      root: {
        display: 'block',
        padding: '0',
      },
    },
    MuiAccordion: {
      root: {
        width: '100%',
        backgroundColor: 'white',
        zIndex: 'unset!important',
      },
    },
    MuiAccordionSummary: {
      root: {
        height: '80px',
        paddingLeft: '0px !important',
        '@media (max-width: 599px)': {
          height: '56px',
          paddingRight: '0px!important',
          '&$expanded': {
            minHeight: '56px',
          },
        },
      },
      content: {
        height: '100%',
        alignItems: 'center',
        margin: '0px',
      },
    },
    MuiAccordionDetails: {
      root: {
        justifyContent: 'center',
        borderTop: '1px solid #e8e9eb !important',
      },
    },
    MuiPickersModal: {
      dialogRoot: {
        minWidth: '330px',
        backgroundColor: 'white',
        maxHeight: 'unset',
      },
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: 'white',
        minHeight: '1px!important',
        justifyContent: 'start',
        height: 'unset',
        paddingLeft: '16px !important',
        paddingTop: '16px!important',
      },
    },
    MuiPickersToolbarText: {
      toolbarTxt: {
        color: 'black',
        fontFamily: 'Lato',
        fontWeight: 700,
      },
      toolbarBtnSelected: {
        color: 'black',
      },
    },
    MuiPickersDatePickerRoot: {
      toolbar: {
        alignItems: 'center',
        flexDirection: 'row-reverse',
      },
    },
    MuiPickersToolbarButton: {
      toolbarBtn: {
        margin: '2px',
      },
    },
    MuiPickersCalendar: {
      transitionContainer: {
        marginBottom: '35px',
        minHeight: '200px',
        marginTop: '0px',
      },
    },
    MuiPickersCalendarHeader: {
      daysHeader: {
        maxHeight: 'unset',
        height: '20px',
        marginBottom: '20px',
      },
      transitionContainer: {
        '& p': {
          color: 'black',
          fontSize: '14px !important',
          fontFamily: 'Lato',
          fontWeight: 700,
        },
      },
      dayLabel: {
        width: '42px',
        color: 'black',
        fontSize: '14px',
        fontFamily: 'Lato',
        fontWeight: 700,
        textTransform: 'Capitalize',
      },
      iconButton: {
        paddingLeft: '12px',
        paddingRight: '12px',
      },
      switchHeader: {
        marginTop: '10px',
      },
    },
    MuiPickersDay: {
      day: {
        width: '40px',
        height: '31px',
        margin: '3px',
      },
      current: {
        color: '#009688',
      },
      daySelected: {
        backgroundColor: colors.accent,
        color: 'white',
        borderRadius: '0%',
        '&:hover': {
          backgroundColor: colors.accent,
          color: 'black',
          borderRadius: '0%',
        },
      },
    },
    MuiPickersBasePicker: {
      pickerView: {
        borderBottom: '1px solid #E8E9EB',
        minHeight: '320px',
        overflowY: 'hidden',
        maxWidth: 'unset',
        alignItems: 'center',
      },
    },
    MuiDialogActions: {
      root: {
        padding: '0px',
      },
    },
    MuiChip: {
      label: {
        textTransform: 'Capitalize',
      },
      outlined: {
        '&.tag-selected': {
          marginRight: 10,
          backgroundColor: colors.accent,
          borderColor: colors.accent,
          marginBottom: 8,
          color: 'white',
          height: 29,
          '& .MuiChip-label': {
            textTransform: 'unset!important',
          },
          '&:hover': {
            backgroundColor: colors.accent,
          },
          '&:focus': {
            backgroundColor: colors.accent,
          },
        },
      },
    },

    MuiSlider: {
      valueLabel: { fontSize: '17px!important' },
      thumb: {
        transform: 'scale(1.1) !important',
      },

      rail: {
        transform: 'scaley(1.1) !important',
      },
    },
    MuiTimelineConnector: {
      root: {
        width: '4px',
        backgroundColor: '#E8E9EB',
        height: '50px',
      },
    },
    MuiTimelineItem: {
      root: {
        height: 'fit-content',
        minHeight: 'unset',
      },
    },
    MuiTimeline: {
      root: {
        minWidth: '650px',
        overflow: 'hidden',
      },
    },
  },
  palette: {
    primary: {
      main: colors.COLOR_PRIMARY,
    },
    secondary: {
      main: colors.COLOR_SECONDARY,
    },
  },
};
